import set from "lodash/set";

export function UPDATE_SEARCH_DATA_RESULTS(nextState, { guid, results }) {
  nextState[guid] = {
    ...nextState[guid],
    results,
  };
}

export function INITIALIZE_SEARCH_DATA(nextState, { guid, results }) {
  const existingState = nextState[guid] || {}
  nextState[guid] = {
    // inputValue: '',
    ...existingState,
    results,
  };
}

export function UPDATE_SEARCH_DATA_INPUT_VALUE(nextState, { guid, inputValue }) {
  nextState[guid] = {
    ...nextState[guid],
    inputValue,
  };
}

export function UPDATE_SEARCH_DATA_DEFAULT_IMAGE(nextState, { guid, defaultImage }) {
  nextState[guid] = {
    ...nextState[guid],
    defaultImage,
  };
}

export function UPDATE_SEARCH_DATA_SELECTED_ITEM(nextState, { guid, selectedItem }) {
  nextState[guid] = {
    ...nextState[guid],
    selectedItem,
  };
}


export function UPDATE_SEARCH_DATA_STEP(nextState, { step }) {
  return {
    ...nextState,
    step,
  };
}

export function UPDATE_SEARCH_DATA_GO_BACK(nextState, { isGoBack }) {
  return {
    ...nextState,
    isGoBack,
  };
}

export function UPDATE_SEARCH_DATA_SHOW_BACK(nextState, { showBack }) {
  return {
    ...nextState,
    showBack,
  };
}

export function UPDATE_SEARCH_DATA_IS_LOADING(nextState, { guid, isLoading }) {
  nextState[guid] = {
    ...nextState[guid],
    isLoading,
  };
}
